export const emailtemplateConstants = {
    GETALL_REQUEST: 'EMAILTEMPLATE_GETALL_REQUEST',
    GETALL_SUCCESS: 'EMAILTEMPLATE_GETALL_SUCCESS',
    GETALL_FAILURE: 'EMAILTEMPLATE_GETALL_FAILURE',

    DELETE_REQUEST: 'EMAILTEMPLATE_DELETE_REQUEST',
    DELETE_SUCCESS: 'EMAILTEMPLATE_DELETE_SUCCESS',
    DELETE_FAILURE: 'EMAILTEMPLATE_DELETE_FAILURE'
};
